import { atom } from "recoil";

export const imageOptimizationCrashedAtom = atom<boolean>({
  key: "ImageOptimizationCrashedAtom",
  default: false,
});
